"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreInitialsAvatar = _interopRequireDefault(require("@vfuk/core-initials-avatar"));

var _corePhotoAvatar = _interopRequireDefault(require("@vfuk/core-photo-avatar"));

var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));

var _coreBaseProps = require("@vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/UserIcon.style"));

var _TopNavigationContext = _interopRequireDefault(require("../../../../../../context/TopNavigationContext"));

var _constants = require("../../../../../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var UserIcon = function UserIcon(_ref) {
  var dataSelectorPrefix = _ref.dataSelectorPrefix;

  var _ref2 = (0, _react.useContext)(_TopNavigationContext["default"]),
      secondaryNav = _ref2.secondaryNav,
      setNavLevel = _ref2.setNavLevel,
      setActiveNav = _ref2.setActiveNav,
      setNavTree = _ref2.setNavTree,
      appearance = _ref2.appearance,
      topNavigationTheme = _ref2.topNavigationTheme;

  if (!(secondaryNav !== null && secondaryNav !== void 0 && secondaryNav.user)) return null;
  var user = secondaryNav.user;

  var userLinks = function userLinks() {
    var userLinksArray = [];

    if (user.links) {
      userLinksArray.push.apply(userLinksArray, _toConsumableArray(user.links));
    }

    if (user.data) {
      userLinksArray.push(user.logout);
    }

    if (!user.data) {
      userLinksArray.push(user.login);
    }

    return userLinksArray;
  };

  var handleClick = function handleClick() {
    setNavLevel(1);
    setActiveNav({
      parentId: user.id,
      links: userLinks()
    });
    setNavTree([{
      level: 1,
      parentId: user.id
    }]);
  };

  var _topNavigationTheme$a = topNavigationTheme.appearance[appearance].mainBar,
      iconAppearance = _topNavigationTheme$a.iconAppearance,
      inverseIcon = _topNavigationTheme$a.inverseIcon;
  return /*#__PURE__*/_react["default"].createElement(Styled.UserIcon, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(Styled.UserLink, {
    onClick: handleClick,
    id: user.id,
    label: user.srText,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, _constants.DataKeys.UserIcon)
  }, user.data ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, user.data.avatar ? /*#__PURE__*/_react["default"].createElement(_corePhotoAvatar["default"], {
    image: user.data.avatar,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'photo-avatar')
  }) : /*#__PURE__*/_react["default"].createElement(_coreInitialsAvatar["default"], {
    initials: user.data.initials,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'initials-avatar')
  })) : /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    name: "admin",
    isResponsive: true,
    size: 4,
    appearance: iconAppearance,
    inverse: inverseIcon,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'icon')
  })));
};

UserIcon.displayName = "UserIcon";
var _default = UserIcon;
exports["default"] = _default;
//# sourceMappingURL=UserIcon.js.map